var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ewz6yiobwa",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D00245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D64D00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#ewz6yiobwa)",
    fillRule: "nonzero",
    transform: "translate(-1041 -805)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 1.28C4.294 1.28 1.28 4.295 1.28 8c0 3.705 3.015 6.72 6.72 6.72 3.705 0 6.72-3.015 6.72-6.72 0-3.705-3.015-6.72-6.72-6.72zm2.773 3.778l.076.067c.284.284.31.728.077 1.041l-.077.09L9.265 7.84l1.584 1.585c.288.288.31.742.066 1.056l-.066.075c-.284.284-.729.31-1.042.078l-.09-.078-1.584-1.584-1.584 1.584c-.288.289-.742.31-1.056.067l-.075-.067c-.284-.284-.31-.728-.077-1.041l.077-.09 1.583-1.585-1.583-1.583c-.288-.288-.31-.742-.067-1.056l.067-.075c.284-.284.729-.31 1.042-.078l.09.078 1.583 1.582 1.584-1.582c.289-.289.742-.311 1.056-.067z",
    transform: "translate(99 106) translate(352 167) translate(0 500) translate(580 25) translate(10 7)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedStatus);
export default __webpack_public_path__ + "static/media/rejected-status.6a0d76cd03e16f1a5781aed37c2e4e5d.svg";
export { ForwardRef as ReactComponent };